export default __webpack_public_path__ + "media/images/content-dog-body-e841f440d98b1e0365957c75e5c096d6.svg";